(function() {
    angular.module("dashboard")
        .component("orderUpOrderItem", {
            templateUrl: "components/store/order-up/order-up-order-item.095996f9.html",
            bindings: {
                ngModel: "<"
            },
            controller: [ OrderItemComponent ]
        });

    function OrderItemComponent() {
    }

    OrderItemComponent.prototype = {
        showComment: function() {
            if (!this.ngModel) {
                return false;
            }
            return this.ngModel.Comment?.trim() !== "";
        }
    };
})();
